import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MaterialModule } from '../../material/material.module';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { JobsService } from '../../services/jobs.service';
import { finalize } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppService } from '../../services/app.service';
import { AnimatedBackgroundComponent } from '../../components/animated-background/animated-background.component';

@Component({
  selector: 'app-login',
  imports: [CommonModule, RouterModule, MaterialModule, ReactiveFormsModule, AnimatedBackgroundComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  private readonly _router = inject(Router);
  private readonly _api = inject(JobsService);
  private readonly _snackBar = inject(MatSnackBar)
  private readonly _service = inject(AppService)

  loginForm: FormGroup;
  hidePassword = true;
  loading = false;
  constructor(private fb: FormBuilder) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  onSubmit() {
    if (this.loading || this.loginForm.invalid) return;
    if (this.loginForm.valid) {
      this.loading = true;
      this._api.login(this.loginForm.value)
        .pipe(finalize(() => (this.loading = false)))
        .subscribe({
          next: (res: any) => {
            this._service.setUserProfile({
              access_token: res.data.access_token,
              refresh_token: res.data.refresh_token,
              role: res.data.role
            })
            this._router.navigate(['/jobs']);
          },
          error: (err: any) => {
            if (err.status == 403) {
              const snackBarRef = this._snackBar.open(err.error.message || 'Account not verified.', 'verify now !')
              snackBarRef.afterDismissed().subscribe((dismiss: any) => {
                if (dismiss.dismissedByAction) {
                  this._router.navigate(['/register'], {
                    state: {
                      data: {
                        email: this.loginForm.value.email
                      }
                    }
                  })
                }
              })
            } else {
              this._snackBar.open(err.error.message || 'Unable to login. Please try again later.')
            }
          }
        });
    }
  }
}
